import React from "react";

import { Chart } from "./Chart";
import RightRail from "./RightRail";
import { PlayerButtons } from "./PlayerButtons";
import { VerticalSlider } from "./VerticalSlider";
import { LeftSideBar } from "./LeftSideBar";
import { ToolBar } from "./Toolbar";

export default function Layout(props) {
  const chartSqSize = 49;
  const chartMinSize = "860px";
  const gridStyle = {
    display: "grid",
    gridTemplateColumns: `[left-slider] 220px [left-slider-gap] 15px [left-chart-slider] 30px [left-chart-gap] 25px [chart-start] minmax(${chartMinSize}, ${chartSqSize}%) [right-chart-gap] 5% [side-bar-start] minmax(300px, 300px)[right-end-gap] minmax(5px,5px) [right-end] minmax(0%, 100%)`,
    gridTemplateRows: `[navbar-start] 76px [chart-row-start] 860px [players-row-start] 30px [footer] minmax(0%, 100%)`,
    gridRowGap: "5px",
    minHeight: "100vh",
    minWidth: "100vh",
  };
  const navBarStyle = {
    columnGap: "0px",
    gridColumnStart: "left-slider-gap",
    gridColumnEnd: "-1",
    gridRowStart: "navbar-start",
    gridRowEnd: "navbar-start",
  };
  const footerStyle = {
    display: "grid",
    gridRow: "footer",
  };
  const leftSideBarStyle = {
    columnGap: "0px",
    gridColumnStart: "left-slider",
    gridColumnEnd: "left-slider",
    gridRowStart: "navbar-start",
    gridRowEnd: "-1",
    display: "grid",
    minWidth: "0%",
  };
  const sliderStyle = {
    gridColumnStart: "left-chart-slider",
    width: "300px",
    gridColumnEnd: "left-chart-slider",
    gridRow: "chart-row-start / chart-row-start",
    display: "grid",
    minWidth: "0%",
    minHeight: "0%",
  };
  const chartAreaStyle = {
    gridColumnStart: "chart-start",
    gridColumnEnd: "chart-start",
    gridRow: "chart-row-start / chart-row-start",
    display: "grid",
    minWidth: "0%",
    minHeight: "0%",
  };
  const playerButtonStyle = {
    gridRowStart: "players-row-start",
    gridRowEnd: "players-row-start",
    gridColumnStart: "chart-start",
    gridColumnEnd: "chart-start",
    minWidth: "0%",
    minHeight: "0%",
  };
  const sidebarWrapperStyle = {
    gridColumnStart: "side-bar-start",
    gridColumnEnd: "side-bar-start",
    gridRow: "chart-row-start / -1",
    display: "grid",
    gridTemplateRows: "minmax(0, 860px)",
    minWidth: "0%",
    minHeight: "0%",
  };
  return (
    <div style={gridStyle}>
      <div style={navBarStyle}>
        <ToolBar />
      </div>
      <div style={leftSideBarStyle}>
        <LeftSideBar />
      </div>
      <div style={sliderStyle}>
        <VerticalSlider />
      </div>
      <div style={chartAreaStyle}>
        <Chart />
      </div>
      <div style={playerButtonStyle}>
        <PlayerButtons />
      </div>
      <div style={sidebarWrapperStyle}>
        <RightRail />
      </div>
      <div style={footerStyle} />
    </div>
  );
}
